module.exports = __webpack_public_path__ + "img/7.e6919b03.jpg";